import React from "react";

import PageBanner from "../components/common/PageBanner";
import Reviews from "../components/ReviewPageComponents/Reviews";

import reviewsBanner from "../assets/review-banner.jpg";

const ReviewPage = () => {
  return (
    <>
      <PageBanner title="Customer Reviews" bgImage={reviewsBanner} />
      <Reviews />
    </>
  );
};

export default ReviewPage;
